import React, { FC, useEffect, useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { Colors } from "../../../helpers/theme";
import { ProjectListHomeProps } from "../../../interfaces";
import Moment from "react-moment";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#ffffff1c !important",
    marginBottom: "10px",

    "& .red": {
      color: Colors.red,
    },
  },
  titleCell: {
    borderRadius: ".9rem",
    paddingLeft: "7rem",
  },
  roi: {
    backgroundColor: "#11302D",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    padding: ".6rem .75rem",
    width: "30%",
    marginRight: "3rem",
  },
  logos: {
    width: "32px",
    height: "32px",
    borderRadius: "50px",
  },
}));
const DesktopView: FC<ProjectListHomeProps> = ({
  id,
  imgSrc,
  title,
  price,
  roi,
  change,
}) => {
  const classes = useStyles();
  const [, setChangeColor] = useState("green");
  useEffect(() => {
    if (change === "- 46%") setChangeColor("red");
    else setChangeColor("green");
  }, []);
  return (
    <>
      <TableRow className={classes.root}>
        <TableCell className={classes.titleCell}>
          <Box display={"flex"} alignItems="center">
            <Box style={{ display: "inline-block" }}>
              <img
                src={imgSrc}
                className={`${classes.logos} img-fluid`}
                alt={title}
              />
            </Box>
            <Box
              className="white font-family-Poppin fw-bold"
              ml={1}
              style={{ display: "inline-block" }}
            >
              {title}
            </Box>
          </Box>
        </TableCell>
        <TableCell align="left">
          <Box className="white font-family-Poppin ml-16">${price}</Box>
        </TableCell>
        <TableCell style={{ marginLeft: "-2rem" }}>
          <Box display={"flex"} justifyContent="center" width={"100%"}>
            <Box className={classes.roi + " white font-family-Poppin fw-bold"}>
              {roi === null ? "100x" : parseFloat(roi).toFixed(1) + " x"}
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
};

export default DesktopView;
